import { Box, Skeleton, Stack, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

export function KeyMetric({
  name,
  value,
  loading,
  href,
  onClick,
}: {
  name: string;
  value: number | string | undefined;
  loading: boolean;
  href?: string;
  onClick?: () => void;
}) {
  const theme = useTheme();
  const isClickable = !!href || !!onClick;

  return (
    <Box
      component={href ? Link : "div"}
      to={href ?? ""}
      preventScrollReset={true}
      onClick={onClick}
      sx={{
        textDecoration: "none",
        cursor: isClickable ? "pointer" : "default",
        py: 1.25,
        px: 1.5,
        borderRadius: 1,
        backgroundColor: theme.palette.mode === "light" 
          ? theme.palette.grey[50] 
          : theme.palette.grey[900],
        border: `1px solid ${theme.palette.divider}`,
        transition: "all 0.15s ease-in-out",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        minWidth: 0,
        overflow: "hidden",
        "&:hover": isClickable
          ? {
              backgroundColor: theme.palette.action.hover,
              borderColor: theme.palette.action.selected,
              transform: "translateY(-1px)",
            }
          : {},
      }}
    >
      <Typography
        variant="h5"
        fontWeight={700}
        color={theme.palette.text.primary}
        lineHeight={1.1}
      >
        {loading ? <Skeleton variant="text" width={35} height={32} /> : value ?? 0}
      </Typography>
      <Typography
        variant="caption"
        color={theme.palette.text.secondary}
        lineHeight={1.3}
        noWrap
        sx={{ mt: 0.5 }}
      >
        {name}
      </Typography>
    </Box>
  );
}
